export default __webpack_public_path__ + "img/caret-down-fill.d1f358ff.svg";